import { createTripleButton, StyleConfig } from '../button/triple-button/triple-button';
import { Color } from '../color/color';
import { FontSize, FontWeight } from '../font';

const styleConfig: StyleConfig = {
  sizing: {
    shrinkX: '8px',
    shrinkY: '8px',
    borderRadius: '4px',
    gap: '8px',
  },
  background: {
    color: {
      base: {
        normal: Color.alpha.white0,
        hover: Color.alpha.white1,
      },
    },
  },
  config: {
    componentId: 'menu-item',
    displayName: 'MenuItem',
  },
};

const MenuItemBase = createTripleButton({
  ...styleConfig,
  text: {
    size: FontSize.l1,
    weight: FontWeight.base,
    color: {
      base: {
        normal: Color.white7,
        hover: Color.white5,
      },
    },
  },
  icon: {
    size: '16px',
    color: {
      base: {
        normal: Color.white7,
        hover: Color.white5,
      },
    },
  },
});

const MenuItemDanger = createTripleButton({
  ...styleConfig,
  background: {
    color: {
      base: {
        normal: 'rgba(255, 0, 0, 0)',
        hover: 'rgba(255, 0, 0, 0.05)',
      },
    },
  },
  text: {
    size: FontSize.l1,
    weight: FontWeight.base,
    color: {
      base: {
        normal: '#9d1c1c',
        hover: '#c01c1c',
      },
    },
  },
  icon: {
    size: '16px',
    color: {
      base: {
        normal: '#9d1c1c',
        hover: '#c01c1c',
      },
    },
  },
});

export function MenuItem({ text, icon, danger, onClick }: { text: string; icon?: any; danger?: boolean; onClick?: () => void }) {
  return danger ? <MenuItemDanger text={text} icon={icon} onClick={onClick} /> : <MenuItemBase text={text} icon={icon} onClick={onClick} />;
}
